<template>
  <div class="wrapper">
    <el-dialog 
      title="跟进记录" 
      :visible.sync="dialogVisible" 
      width="900px"
      class="remark-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <tp-table
          :isNeedSerialNumber="true"
          :tableData="list"
          :columns="columns"
          :totalNum="total"
          :current-page.sync="currentPage"
          :pageSize.sync="pageSize"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderRemarkAPI } from './api'
const columns = [
  {
    label: '时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return (
        <div class="table-cell">
          <i class="el-icon-time time-icon"></i>
          <span class="time-text">{row['createTime'] || '-'}</span>
        </div>
      )
    }
  },
  {
    label: '审核人',
    prop: 'identitraceUsertyNo',
    minWidth: '150',
    customRender(h, row) {
      return (
        <div class="table-cell">
          <i class="el-icon-user user-icon"></i>
          <span class="user-text">{row['traceUser']?.['userName'] || '-'}</span>
        </div>
      )
    }
  },
  {
    label: '备注',
    prop: 'content',
    minWidth: '300',
    customRender(h, row) {
      return (
        <div class="table-cell remark-cell">
          <i class="el-icon-edit-outline remark-icon"></i>
          <span class="remark-text">{row['content'] || '-'}</span>
        </div>
      )
    }
  }
]
export default {
  name: 'Remark',
  props: {
    memberId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: []
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getAfterSaleRemark(this.memberId)
    },
    pageSize() {
      this.getAfterSaleRemark(this.memberId)
    }
  },
  mounted() {
    // this.getAfterSaleRemark()
  },

  methods: {
    async getAfterSaleRemark(memberId) {
      const params = { page: this.currentPage, pageSize: this.pageSize, memberId }
      const res = await getOrderRemarkAPI(params)
      this.total = res.total || 0
      this.list = res.list || []
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  
  ::v-deep .remark-dialog {
    .el-dialog {
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
      
      .el-dialog__header {
        background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
        padding: 20px 24px;
        border-bottom: none;
        
        .el-dialog__title {
          color: #ffffff;
          font-size: 18px;
          font-weight: 600;
          display: flex;
          align-items: center;
          
          &::before {
            content: '';
            display: inline-block;
            width: 4px;
            height: 18px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 2px;
            margin-right: 12px;
          }
        }
        
        .el-dialog__headerbtn {
          top: 20px;
          right: 24px;
          
          .el-dialog__close {
            color: rgba(255, 255, 255, 0.9);
            font-size: 20px;
            transition: all 0.3s ease;
            
            &:hover {
              color: #ffffff;
              transform: rotate(90deg);
            }
          }
        }
      }
      
      .el-dialog__body {
        padding: 24px;
        background: #fafbfc;
      }
    }
  }
  
  .dialog-content {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
  
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
    
    ::v-deep .el-table {
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      
      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 600;
        font-size: 14px;
        padding: 16px 0;
        border-bottom: 2px solid #E4E7ED;
        
        &:first-child {
          padding-left: 20px;
        }
      }
      
      tbody {
        tr {
          transition: all 0.25s ease;
          border-bottom: 1px solid #F0F2F5;
          
          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }
          
          td {
            padding: 16px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }
    }
    
    .table-cell {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #606266;
      font-size: 14px;
      
      i {
        font-size: 16px;
        flex-shrink: 0;
      }
      
      .time-icon {
        color: #409EFF;
      }
      
      .user-icon {
        color: #67C23A;
      }
      
      .remark-icon {
        color: #E6A23C;
      }
      
      .time-text,
      .user-text {
        font-weight: 500;
      }
      
      .remark-text {
        line-height: 1.6;
        word-break: break-word;
        color: #303133;
      }
      
      &.remark-cell {
        align-items: flex-start;
        
        .remark-icon {
          margin-top: 2px;
        }
      }
    }
    
    .pagination {
      margin-top: 20px;
      padding-top: 20px;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
      }
    }
  }
  
  .submit {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
